// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1sSlR","title":"AfterBackImages_title__38XDe","images":"AfterBackImages_images__1BIs-"};